import { KYMW2300Model } from '../kymw2300.model';
import { CheckProgressHistoryModel } from '../vo/check-progress-history.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 印刷会社用データ出力画面　工程履歴チェックをするサービス
 *
 * @export CheckProgressHistoryService
 * @class CheckProgressHistory
 * @extends {PlessResponderSub}
 */
@Injectable()
export class CheckProgressHistoryService extends PlessJsonResponderSub<any> {

  /**
   * 処理に使用するModel
   *
   * @private
   * @type {KYMW2300Model}
   * @memberof CheckProgressHistoryService
   */
  private model: KYMW2300Model;
  private vo: CheckProgressHistoryModel;

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof CheckProgressHistoryService
   */
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof CheckProgressHistoryService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        OrderCode: this.vo.orderCode,
        MediumType: this.vo.mediumType,
        ProgressNum: this.vo.progressNum
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param {Function} successFunc 成功時後続処理
   * @memberof CheckProgressHistoryService
   */
  execute(model: KYMW2300Model, vo: CheckProgressHistoryModel, successFunc: Function): void {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('KYMW23CheckProgressHistory', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof CheckProgressHistoryService
   */
  success(data: any): void {
    if (data === null) {
      return;
    }
    if (data.CheckResult === 'NG') {
      switch(this.vo.checkType) {
        case '1':
          this.dialogService.openAlertGetMessage('E0207', ['選択した工程', 'フェーズ未確定', '選択'],
          (closeDetail) => {
            this.model.rollBackCmbTargetProgress(closeDetail);
          });
          return;
        case '2':
          this.dialogService.openAlertGetMessage('E0207', ['選択した工程', 'フェーズ未確定', '選択'],
          (closeDetail) => {
            this.model.rollBackCmbCompareProgress(closeDetail);
          });
          return;
      }
    }
    switch(this.vo.checkType) {
      case '1':
        // ページ取得イベントを発行する
        this.model.kymw2300Component.dispatcherGetPageInfoEvent();
        this.model.selectedTargetProgressNum = this.model.kymw2300Component.cmb_TargetProgress.selectedCodeValue;
        return;
      case '2':
        this.model.selectedCompareProgressNum = this.model.kymw2300Component.cmb_CompareProgress.selectedCodeValue;
        return;
    }
  }
}
